import { create } from 'zustand';

type TabType = 'details' | 'dependencies' | 'assignments' | 'comments' | 'history';

interface TaskPanelState {
  isOpen: boolean;
  taskId: string | null;
  activeTab: TabType;

  // Actions
  openPanel: (taskId: string, tab?: TabType) => void;
  closePanel: () => void;
  setActiveTab: (tab: TabType) => void;
}

export const useTaskPanelStore = create<TaskPanelState>((set) => ({
  isOpen: false,
  taskId: null,
  activeTab: 'details',

  openPanel: (taskId, tab = 'details') => {
    set({ isOpen: true, taskId, activeTab: tab });
  },

  closePanel: () => {
    set({ isOpen: false, taskId: null });
  },

  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },
}));

export type { TabType };
